import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import { OverviewIntro } from '../../../components';

import './style.scss';

const ArticlesPillarOverview = ({ onLoadMore, pager, loading, entities, ...props }) => {
  const url = `${window.location.pathname}/artikelen`;
  const className = 'col-12 col-md-4 ArticlesPillarOverview__item-wrapper';
  return (
    <div className="View ArticlesPillarOverview">
      <div className="row no-gutters">
        <div className={className}>
          <OverviewIntro title="Bekijk alle artikelen" link={url}>
            <h2>Artikelen</h2>
            <p>Nullam id dolor id nibh ultricies vehicula ut id elit. Donec sed odio dui. Praesent commodo cursus magna, vel scelerisque.</p>
          </OverviewIntro>
        </div>
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ArticlesPillarOverview;
